import { STATUS_TYPES } from './STATUS_TYPES';
export var TAG_APPEARANCES = Object.freeze(Object.assign({}, STATUS_TYPES, {
  closeable: 'closeable',
  gray: 'gray',
  transparent: 'transparent',
  purple: 'purple',
  aqua: 'aqua',
  orange: 'orange'
}));